/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import EstadoCumplimientoPedido from 'Infotrack@Modelos/smartStock/estadisticasDashboard/entidades/estadoCumplimientoPedido';
import { AnyAction } from 'redux';

export interface IEstadoMonitorPedidos {
  filtrosEstadisticas: {
    bodegaId: number;
    clienteId?: number;
    etapaId?: number;
    estadoCumplimientoPedido?: EstadoCumplimientoPedido;
  };
  formularioEstadoPedidos: boolean;
  formularioEstadoCumplimientoPedidos: boolean;
}

export const estadoInicial: IEstadoMonitorPedidos = {
  filtrosEstadisticas: {
    bodegaId: 0,
    clienteId: undefined,
    etapaId: undefined,
    estadoCumplimientoPedido: undefined,
  },
  formularioEstadoPedidos: false,
  formularioEstadoCumplimientoPedidos: false,
};

export enum acciones {
  CAMBIAR_FORMULARIO_ESTADO_PEDIDOS = 'CAMBIAR_FORMULARIO_ESTADO_PEDIDOS',
  CAMBIAR_FORMULARIO_ESTADO_CUMPLIMIENTO_PEDIDOS = 'CAMBIAR_FORMULARIO_ESTADO_CUMPLIMIENTO_PEDIDOS',
  ESTABLECER_FILTROS_ESTADISTICAS = 'ESTABLECER_FILTROS_ESTADISTICAS',
}

export const reductor = (estado: IEstadoMonitorPedidos = estadoInicial, { type, payload }: AnyAction) => {
  switch (type) {
    case acciones.CAMBIAR_FORMULARIO_ESTADO_PEDIDOS:
      return {
        ...estado,
        formularioEstadoPedidos: !estado.formularioEstadoPedidos,
      };

    case acciones.CAMBIAR_FORMULARIO_ESTADO_CUMPLIMIENTO_PEDIDOS:
      return {
        ...estado,
        formularioEstadoCumplimientoPedidos: !estado.formularioEstadoCumplimientoPedidos,
      };

    case acciones.ESTABLECER_FILTROS_ESTADISTICAS:
      return {
        ...estado,
        filtrosEstadisticas: { ...estado.filtrosEstadisticas, ...payload },
      };
    default:
      return estado;
  }
};
